import React, { useState } from "react";
// UI Frameworks
import { TableCell } from "@mui/material";
import { toast } from "react-toastify";
import { DeleteFilled, EditFilled } from "@ant-design/icons";
// Common Components
import { Modal } from "src/Components";
import Loading from "src/Components/Loading/Loading";
// Local Components
import AddOrEditModal from "./AddOrEditModal";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Interfaces
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import { IBaseHedgerPairTableReport } from "src/Interfaces/automaticMarketMaking";
// Requests
import { deleteBaseHedgerPairTask } from "src/Requests/automaticMarketMaking";

const BaseHedgerPairAdditionalHeader = (props: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IBaseHedgerPairTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  // local store
  const [loading, setLoading] = React.useState(false);

  const deleteHandler = () => {
    setLoading(true);
    deleteBaseHedgerPairTask(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <TableCell>
        {isEditModalOpen ? (
          <Modal
            title="ویرایش جفت هج"
            UI={
              <AddOrEditModal
                onSuccess={onAction}
                editValues={{
                  id: row.id,
                  baseInsId: row.baseInsId,
                  hedgeInsId: row.hedgeInsId,
                  refrenceRemainingType: row.hedgerRefrenceDueDateType,
                  refrecnceRemainingManualValue: row.hedgerRefrenceDueDateStr,
                  refrenceDueDate: row.hedgerLongTermsTurbulence,
                  v_100_Base_Percent: row.v_100_Base_Percent,
                  v_100_Hedger_Percent: row.v_100_Hedger_Percent,
                  iV_inf_turbulence: row.iV_inf_turbulence,
                  baseToHedgerPerformance: row.baseToHedgerPerformance,
                  baseToHedgerRate: row.baseToHedgerRate,
                  sentiment: row.sentiment,
                  maxIV_30_Base: row.maxIV_30_Base,
                  minIV_30_Base: row.minIV_30_Base,
                  accountIds: row.accounts.map((item) => item.id),
                  longtermHedgerVolatility: row.longtermHedgerVolatility,
                }}
                onClose={() => setIsEditModalOpen(false)}
              />
            }
            onClose={() => setIsEditModalOpen(false)}
          />
        ) : (
          <></>
        )}
        <div className="w-16 mx-auto" onClick={() => setIsEditModalOpen(true)}>
          <EditFilled />
        </div>
      </TableCell>
      <TableCell>
        <div className="w-16" onClick={deleteHandler}>
          {loading ? (
            <Loading size={16} className="!text-white" />
          ) : (
            <DeleteFilled />
          )}
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IBaseHedgerPairTableReport> = {
  getHeader: BaseHedgerPairAdditionalHeader,
  getRow: AdditionalCol,
};
